/**
 * Created by Ning Jiang on 6/20/2018.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Back, TimelineLite, TimelineMax, TweenLite} from "gsap";
import {FruitsGameConfig} from "../FruitsGameConfig";
import {FruitsGameModuleConfig} from "../FruitsGameModuleConfig";
import {FruitsSoundConfig} from "../FruitsSoundConfig";
import {FruitsGameMode} from "../gamemode/FruitsGameMode";
import {FruitsReelSymbol} from "../reelsymbol/FruitsReelSymbol";
import {FruitsHelper} from "../utils/FruitsHelper";
import {BigStickySymbolController} from "./BigStickySymbolController";

export interface ISpriteObject {
    sprite:PIXI.Sprite,
    originX:number,
    originY:number,
    toX:number,
    toY:number
}

export class BigStickySymbolView extends BaseView {

    private _layer:ScalableLayer;
    private _currentSymbolName:string = "";
    private _x2Container:PIXI.Container;
    private _container:PIXI.Container;
    private _screenWidth:number;
    private _screenHeight:number;
    private _leftOffset:number;
    private _topOffset:number;
    private _centerX:number = FruitsGameConfig.instance.GAME_WIDTH * 0.5;
    private _centerY:number = FruitsGameConfig.instance.GAME_HEIGHT * 0.5;
    private _stickyBg:PIXI.Sprite;
    private _x2Graphic:PIXI.Graphics;
    private _winSymbol:PIXI.Sprite;
    private _stickyFxSplash:TimelineSprite;
    private _fxStars:PIXI.Sprite;
    private _bgRays:PIXI.Sprite;
    private _respinA:TimelineSprite;
    private _respinB:TimelineSprite;
    private _stickyFxFilter:PIXI.filters.ColorMatrixFilter;
    private _rainbowLower:TimelineSprite;
    private _rainbowContainer:PIXI.Container;
    private _rainbowUpper:TimelineSprite;
    private _bgLayer:ScalableLayer;
    private _rainbowLoop:TimelineMax;
    private _x2Pos:[number, number];
    private _orientation:Orientation;
    private _smallSymContainer:PIXI.Container;
    private _angles:number[];
    private _mainTl:TimelineLite | null;
    private _anglesLandscape:number[];
    private _anglesPortrait:number[];


    constructor() {
        super();

        this._layer = StageManager.getLayer(FruitsGameConfig.instance.LAYERS.STICKY_PRESENTATIONS.name);
        this._bgLayer = StageManager.getLayer(FruitsGameConfig.instance.LAYERS.REEL_BACKGROUND.name);

        this._anglesLandscape = [-135, 135, -45, 45];
        this._anglesPortrait = [-45, -135, 45, 135];
    }

    protected initAnimations():void {
        this._rainbowContainer = new PIXI.Container();
        this._rainbowContainer.alpha = 0;


        this._bgLayer.addChild(this._rainbowContainer);


        this._x2Pos =
            [
                (GameConfig.instance.REEL_AREA_WIDTH - FruitsGameConfig.instance.REELS_X4_SIZE[0] + FruitsGameConfig.instance.REELS_PARTS_OVERLAP) * 0.5 + GameConfig.instance.REEL_AREA_POS_X,
                GameConfig.instance.REEL_AREA_HEIGHT * 0.5 + FruitsGameConfig.instance.REELS_LANDSCAPE_OFFSET_Y + GameConfig.instance.REEL_AREA_POS_Y
            ];


        this._x2Container = new PIXI.Container();
        this._x2Container.position.set(
            (GameConfig.instance.REEL_AREA_WIDTH - FruitsGameConfig.instance.REELS_X4_SIZE[0] + FruitsGameConfig.instance.REELS_PARTS_OVERLAP) * 0.5 + GameConfig.instance.REEL_AREA_POS_X,
            GameConfig.instance.REEL_AREA_HEIGHT * 0.5 + FruitsGameConfig.instance.REELS_LANDSCAPE_OFFSET_Y + GameConfig.instance.REEL_AREA_POS_Y
        );

        this._smallSymContainer = new PIXI.Container();
        this._layer.addChild(this._smallSymContainer);
        this._layer.addChild(this._x2Container);

        this._container = new PIXI.Container();
        this._layer.addChild(this._container);

        this.createGraphics();
        this.createRainbow();
        this.createRainbowLoop();
    }

    private createGraphics() {

        // --- 2x
        this._stickyBg = new PIXI.Sprite(GameResources.getTextures("Sticky_BG")[0]);
        this._stickyBg.anchor.set(0.5, 0.5);
        this._stickyBg.visible = false;

        this._x2Graphic = new PIXI.Graphics();
        this._x2Graphic.beginFill(0xffffff, 1);
        this._x2Graphic.alpha = 0;
        this._x2Graphic.drawRoundedRect(
            -FruitsGameConfig.instance.REELS_X2_SIZE[0] * 0.5,
            -FruitsGameConfig.instance.REELS_X2_SIZE[1] * 0.5,
            FruitsGameConfig.instance.REELS_X2_SIZE[0],
            FruitsGameConfig.instance.REELS_X2_SIZE[1],
            15
        );
        this._x2Graphic.endFill();

        this._winSymbol = this.createSprite2X("L1_normal");
        this._winSymbol.scale.set(0.5, 0.5);

        this._stickyFxSplash = new TimelineSprite(GameResources.getTextures("StickyFxSplash"));
        this._stickyFxSplash.hide();
        this._stickyFxSplash.anchor.set(0.5, 0.5);

        this._stickyFxFilter = new PIXI.filters.ColorMatrixFilter();
        this._stickyFxSplash.filters = [this._stickyFxFilter];

        this._fxStars = new PIXI.Sprite(GameResources.getTextures("FX_Stars")[0]);
        this._fxStars.anchor.set(0.5, 0.5);
        this._fxStars.visible = false;


        this._x2Container.addChild(this._stickyBg);
        this._x2Container.addChild(this._x2Graphic);
        this._x2Container.addChild(this._winSymbol);
        this._x2Container.addChild(this._stickyFxSplash);
        this._x2Container.addChild(this._fxStars);


        // --- main

        this._bgRays = new PIXI.Sprite(GameResources.getTextures("Bg_Rays")[0]);
        this._bgRays.blendMode = PIXI.BLEND_MODES.ADD;
        this._bgRays.scale.set(1.5, 1.5);
        this._bgRays.alpha = 1;
        this._bgRays.visible = false;
        this._bgRays.anchor.set(0.5, 0.5);
        this._bgRays.position.set(640, 360);

        this._respinA = new TimelineSprite(GameResources.getTextures("Respin_A"));
        this._respinA.alpha = 0;
        this._respinA.anchor.set(0.5, 0.5);
        this._respinA.position.set(this._centerX, GameConfig.instance.GAME_HEIGHT * 0.5 - 100);

        this._respinB = new TimelineSprite(GameResources.getTextures("Respin_B"));
        this._respinB.alpha = 0;
        this._respinB.anchor.set(0.5, 0.5);
        this._respinB.position.set(this._centerX, GameConfig.instance.GAME_HEIGHT * 0.5 + 20);

        this._container.addChild(this._bgRays);
        this._container.addChild(this._respinA);
        this._container.addChild(this._respinB);

    }

    private createSprite2X(_texturePath:string):PIXI.Sprite {
        let sp = new PIXI.Sprite(GameResources.getTextures(_texturePath)[0]);

        sp.anchor.set(0.5, 0.5);
        sp.alpha = 0;

        this._container.addChild(sp);

        return sp;
    }

    protected onResize(resizeData:IResizeData):void {

        this._screenWidth = resizeData.width / this._layer.scale.x;
        this._screenHeight = resizeData.height / this._layer.scale.y;
        this._leftOffset = -this._layer.x / this._layer.scale.x;
        this._topOffset = -this._layer.y / this._layer.scale.y;
        this._centerX = this._screenWidth / 2 + this._leftOffset;
        this._centerY = this._screenHeight / 2 + this._topOffset;

        this._orientation = resizeData.orientation;

        // if (this._mainTl && this._mainTl.isActive()) {
        //     this._mainTl.progress(1);
        // }

        if(resizeData.orientation === Orientation.PORTRAIT) {
            this._x2Container.position.set(
                GameConfig.instance.REEL_AREA_WIDTH * 0.5 + GameConfig.instance.REEL_AREA_POS_X,
                FruitsGameConfig.instance.REEL_PORTRAIT_VERTICAL_BORDER + FruitsGameConfig.instance.REELS_X2_SIZE[0] * 0.5 + GameConfig.instance.REEL_AREA_POS_Y
            );

            this._rainbowContainer.position.set(
                GameConfig.instance.REEL_AREA_WIDTH * 0.5 + GameConfig.instance.REEL_AREA_POS_X,
                FruitsGameConfig.instance.REEL_PORTRAIT_VERTICAL_BORDER + FruitsGameConfig.instance.REELS_X2_SIZE[0] * 0.5 + GameConfig.instance.REEL_AREA_POS_Y
            );

            this._x2Pos = [
                GameConfig.instance.REEL_AREA_WIDTH * 0.5 + GameConfig.instance.REEL_AREA_POS_X,
                FruitsGameConfig.instance.REEL_PORTRAIT_VERTICAL_BORDER + FruitsGameConfig.instance.REELS_X2_SIZE[0] * 0.5 + GameConfig.instance.REEL_AREA_POS_Y
            ];

            this._rainbowContainer.rotation = 90 * PIXI.DEG_TO_RAD;
            this._bgRays.rotation = 90 * PIXI.DEG_TO_RAD;
            this._bgRays.scale.set(1.5, 1.5);

        } else {
            this._x2Container.position.set(
                (GameConfig.instance.REEL_AREA_WIDTH - FruitsGameConfig.instance.REELS_X4_SIZE[0] + FruitsGameConfig.instance.REELS_PARTS_OVERLAP) * 0.5 + GameConfig.instance.REEL_AREA_POS_X,
                GameConfig.instance.REEL_AREA_HEIGHT * 0.5 + FruitsGameConfig.instance.REELS_LANDSCAPE_OFFSET_Y + GameConfig.instance.REEL_AREA_POS_Y
            );
            this._rainbowContainer.position.set(
                (GameConfig.instance.REEL_AREA_WIDTH - FruitsGameConfig.instance.REELS_X4_SIZE[0] + FruitsGameConfig.instance.REELS_PARTS_OVERLAP) * 0.5 + GameConfig.instance.REEL_AREA_POS_X,
                GameConfig.instance.REEL_AREA_HEIGHT * 0.5 + FruitsGameConfig.instance.REELS_LANDSCAPE_OFFSET_Y + GameConfig.instance.REEL_AREA_POS_Y
            );

            this._x2Pos = [
                (GameConfig.instance.REEL_AREA_WIDTH - FruitsGameConfig.instance.REELS_X4_SIZE[0] + FruitsGameConfig.instance.REELS_PARTS_OVERLAP) * 0.5 + GameConfig.instance.REEL_AREA_POS_X,
                GameConfig.instance.REEL_AREA_HEIGHT * 0.5 + FruitsGameConfig.instance.REELS_LANDSCAPE_OFFSET_Y + GameConfig.instance.REEL_AREA_POS_Y
            ];

            this._rainbowContainer.rotation = 0;
            this._bgRays.rotation = 0;
            this._bgRays.scale.set(1.5, 1.5);
        }
    }

    private getHue(symbol:string):number {
        switch(symbol) {
            case "M1":
                return -30;

            case "M2":
            case "M3":
            case "L1":
                return 0;

            case "M4":
            case "L2":
                return 80;

            case "M5":
            case "M6":
            case "L3":
                return 125;

            case "L4":
                return -126;

            default:
                return 0;
        }

    }

    public getStickyAnimation2x2(symbolName:string, isRestore:boolean, isOrientation:boolean = false):TimelineLite {
        let tl:TimelineLite = new TimelineLite();

        if(symbolName === this._currentSymbolName) {
            return tl;
        }

        this._currentSymbolName = symbolName;

        this._stickyFxFilter.hue(this.getHue(symbolName), true);
        this._winSymbol.texture = GameResources.getTextures(`${symbolName}_normal`)[0];

        tl.add(this.getBigStickySymbolAnimation(symbolName));
        return tl;
    }

    public getStickyAnimationScreen():TimelineLite {
        return this.getStickyIntroAnimation();
    }

    private createSmallSprites(symName:string, outro:boolean = false):ISpriteObject[] {

        let smallSpriteObjs = [];

        for(let i:number = 0; i < 4; i++) {
            const symInd:[number, number] = FruitsHelper.translateReelIndex(i);
            const rectPos:number[] = FruitsHelper.getSymbolPosition(symInd[0], symInd[1], this._orientation, "NORMAL");
            const originX = rectPos[0];
            const originY = rectPos[1];

            const symSprite = new PIXI.Sprite(GameResources.getTextures(`${symName}_normal`)[0]);
            symSprite.anchor.set(0.5, 0.5);
            symSprite.scale.set(0.5, 0.5);
            symSprite.alpha = 0;
            symSprite.position.set(originX, originY);
            if(outro) {
                symSprite.position.set(this._x2Pos[0], this._x2Pos[1]);
            }


            this._smallSymContainer.addChild(symSprite);

            let angels = this._orientation === Orientation.PORTRAIT ? this._anglesPortrait : this._anglesLandscape;

            let toX = rectPos[0] + 50 * Math.cos(angels[i] * PIXI.DEG_TO_RAD);
            let toY = rectPos[1] + 50 * Math.sin(angels[i] * PIXI.DEG_TO_RAD);

            let spriteObj = {
                sprite : symSprite,
                originX : originX,
                originY : originY,
                toX : toX,
                toY : toY
            };

            smallSpriteObjs.push(spriteObj)

        }

        return smallSpriteObjs;
    }

    private hideShowOldSmallSyms(show:boolean):void {
        const miniReelSize = 4;

        for(let i:number = 0; i < miniReelSize; i++) {
            Reels.getReel(i)!.view.alpha = show ? 1 : 0;
        }
    }

    private getSmallSymAnimationIntro(symName:string):TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        const smallSpritesObj:ISpriteObject[] = this.createSmallSprites(symName);

        this.hideShowOldSmallSyms(false);

        for(let i = 0; i < smallSpritesObj.length; i++) {
            let smalSpObj:ISpriteObject = smallSpritesObj[i];

            smalSpObj.sprite.alpha = 1;
            tl.add(TweenLite.to(smalSpObj.sprite.position, 0.8, {x : smalSpObj.toX, y : smalSpObj.toY}), 0);
            tl.add(TweenLite.to(smalSpObj.sprite.position, 0.2, {x : this._x2Pos[0], y : this._x2Pos[1]}), 0.8);
            tl.add(() => smalSpObj.sprite.alpha = 0, 1);
        }
        SlotGame.sound.playEffect(FruitsSoundConfig.STICKY_SYMBOLS_COLLIDE);
        tl.add(this._stickyFxSplash.getAnimationAutoShowHide(true, false, [0, 5]));

        return tl;
    }

    private getSmallSymAnimationOutro(symName:string):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        const smallSpritesObj:ISpriteObject[] = this.createSmallSprites(symName, true);


        this.changeSymbolStateFromRespinToNormal();

        for(let i = 0; i < smallSpritesObj.length; i++) {
            let smalSpObj:ISpriteObject = smallSpritesObj[i];

            smalSpObj.sprite.alpha = 1;
            tl.add(TweenLite.to(smalSpObj.sprite.position, 0.2, {x : smalSpObj.toX, y : smalSpObj.toY}), 0);
            tl.add(TweenLite.to(smalSpObj.sprite.position, 0.05, {x : smalSpObj.originX, y : smalSpObj.originY}), .2);
            tl.add(() => { smalSpObj.sprite.alpha = 0 }, 0.25);
        }
        // Works fine if to use voids if the objects inside is not changing to other objects.
        tl.add(() => this.hideShowOldSmallSyms(true));

        return tl;
    }

    private changeSymbolStateFromRespinToNormal():void {
        for(let i:number = 0; i < FruitsGameConfig.instance.REELS_NUM; i++) {
            let sym:FruitsReelSymbol = <FruitsReelSymbol>Reels.getSymbol(i, 0);
            if(sym && sym.currentState!.keyword === "respin") {
                sym.changeState({
                    state : FruitsGameConfig.instance.SYMBOL_STATES.normal,
                    fadeInDuration : 0.25,
                    setStack : false
                });
            }
        }
    }

    private getBigStickySymbolAnimation(symName:string):TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        const customEase:CustomEase = CustomEase.create("custom", "M0,0 C0.128,0.572 0.211,1.165 0.474,1.204 0.638,1.228 0.632,0.918 0.76,0.918 0.85,0.918 0.943,1 1,1");

        tl.add(this.getSmallSymAnimationIntro(symName));

        tl.add([
            () => this._stickyBg.visible = true,
            TweenLite.fromTo(this._stickyBg, 0.15, {alpha : 0}, {alpha : 1}),
            this._stickyFxSplash.getAnimation([5, 10]),

            TweenLite.to(this._winSymbol, 0.05, {alpha : 1}),
            TweenLite.to(this._winSymbol.scale, 0.5, {x : 1, y : 1, ease : customEase}),
        ]);

        tl.add([
            this._stickyFxSplash.getAnimationAutoShowHide(true, true, [10, 19]),
            () => this._fxStars.visible = true,
            TweenLite.to(this._fxStars.position, 0.4, {y : "-= 240"}),
            TweenLite.to(this._fxStars, 0.4, {alpha : 0}),
        ]);


        return tl;
    }

    private getStickyIntroAnimation():TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        const bgRayTL:TimelineLite = new TimelineLite();
        bgRayTL.add([
            () => this._bgRays.visible = true,
            () => SlotGame.sound.playEffect(FruitsSoundConfig.STICKY_SPLASH_SCREEN),
            TweenLite.to(this._bgRays, 1, {alpha : 0})
        ]);

        tl.add([
            TweenLite.fromTo(this._respinA.position, 0.25, {x : this._centerX - 150}, {
                x : this._centerX + 10,
                ease : Back.easeOut.config(1.5)
            }),
            TweenLite.fromTo(this._respinB.position, 0.25, {x : this._centerX + 150}, {
                x : this._centerX - 10,
                ease : Back.easeOut.config(1.5)
            }),
            TweenLite.to(this._respinA, 0.15, {alpha : 1}),
            TweenLite.to(this._respinB, 0.15, {alpha : 1})
        ]);

        tl.add([
            TweenLite.to(this._respinA.position, 0.4, {x : this._centerX}),
            TweenLite.to(this._respinB.position, 0.4, {x : this._centerX})
        ]);

        tl.add(bgRayTL, "-= 0.85");

        tl.add([
            TweenLite.to(this._container, 0.4, {alpha : 0}),
            // TweenLite.to(this._rainbowContainer, 0.4, {alpha: 1})
        ], "+=0.5");

        tl.add(() => {EventHandler.dispatchEvent(new GameEvent(BigStickySymbolController.STICK_SYMBOLS))});
        FruitsGameModuleConfig.logoAnimationBit.changeLogo(FruitsGameMode.STICKY_RESPIN);

        return tl;
    }

    public endBigStickyAnimation(symName:string, nextMode:string):TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        if(!this._currentSymbolName || this._currentSymbolName.length === 0) {
            return tl;
        }

        tl.add([
            TweenLite.to(this._winSymbol.scale, 0.2, {x : 0.5, y : 0.5}),
            TweenLite.to(this._stickyBg, 0.2, {alpha : 0}),
        ]);
        tl.add([
            this.getSmallSymAnimationOutro(symName),
            () => this._winSymbol.alpha = 0,
        ]);


        tl.add(() => {
            this.resetSticky();
            this.resetRainbow();
        });

        if(nextMode === FruitsGameMode.NORMAL)
            FruitsGameModuleConfig.logoAnimationBit.changeLogo(nextMode);

        return tl;
    }

    private resetSticky() {
        this._winSymbol.scale.set(0.5, 0.5);
        this._winSymbol.alpha = 0;
        this._x2Graphic.alpha = 0;
        this._stickyBg.visible = false;
        this._stickyBg.alpha = 0;
        this._fxStars.visible = false;
        this._fxStars.position.set(0, 0);
        this._fxStars.alpha = 1;
        this._stickyFxSplash.hide();

        this._smallSymContainer.removeChildren();

        this._respinA.position.set(this._centerX, GameConfig.instance.GAME_HEIGHT * 0.5 - 100);
        this._respinB.position.set(this._centerX, GameConfig.instance.GAME_HEIGHT * 0.5 + 20);
        this._respinA.alpha = 0;
        this._respinB.alpha = 0;
        this._bgRays.visible = false;
        this._bgRays.alpha = 1;
        this._container.alpha = 1;

        this._currentSymbolName = "";
    }


    private createRainbow() {
        this._rainbowLower = new TimelineSprite(GameResources.getTextures("FX_Rainbow"));
        this._rainbowLower.anchor.set(0.5, 0);
        this._rainbowLower.position.set(0, FruitsGameConfig.instance.REELS_X2_SIZE[0] * 0.25);
        this._rainbowContainer.addChild(this._rainbowLower);

        this._rainbowUpper = new TimelineSprite(GameResources.getTextures("FX_Rainbow"));
        this._rainbowUpper.anchor.set(0.5, 0);
        this._rainbowUpper.position.set(0, -FruitsGameConfig.instance.REELS_X2_SIZE[0] * 0.25);
        this._rainbowUpper.scale.x = -1;
        this._rainbowUpper.rotation = 180 * PIXI.DEG_TO_RAD;
        this._rainbowContainer.addChild(this._rainbowUpper);

    }

    private createRainbowLoop():void {
        this._rainbowLoop = new TimelineMax({repeat : -1, paused : true});
        this._rainbowLoop.add([
            this._rainbowLower.getAnimationAutoShowHide(true, false),
            this._rainbowUpper.getAnimationAutoShowHide(true, false)
        ])
    }

    public startRainbowLoop():void {
        this._rainbowLoop.play(0);
    }

    public stopRainbowLoop():void {
        this._rainbowLoop.pause();
    }

    public resetRainbow():void {
        TweenLite.to(this._rainbowContainer, 0.25, {alpha : 0});
        this.stopRainbowLoop();
    }

    public showRainbow():void {
        TweenLite.to(this._rainbowContainer, 0.25, {alpha : 1});
        this._rainbowUpper.show();
        this._rainbowLower.show();
    }
}









